import { useStyletron } from 'baseui'
import { useTranslation } from 'react-i18next'

interface OfferCellProps {
  provider: string
  offer: string
  situation: string | null
  energyType: string | null
  carGas: any
  carElecBase: any
  carElecHp: any
  carElecHc: any
  monthlyAmount: any
}

const getPrestationColor = (prestation: string) => {
  switch (prestation) {
    case 'cdf':
      return 'purple'
    case 'mes':
      return 'goldenrod'
    default:
      return 'grey'
  }
}

const OfferCell = ({
  provider,
  offer,
  situation,
  energyType,
  carGas,
  carElecBase,
  carElecHp,
  carElecHc,
  monthlyAmount,
}: OfferCellProps) => {
  const [css] = useStyletron()
  const { t } = useTranslation()
  const containerStyle = css({
    display: 'flex',
    gap: '.5rem',
    justifyContent: 'space-between',
    width: '100%',
  })
  const leftColumnStyle = css({
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 60%',
  })
  const rightColumnStyle = css({
    display: 'flex',
    flexDirection: 'column',
    flex: '0 0 auto',
    alignItems: 'flex-end',
    textAlign: 'right' as const,
  })
  const rowStyle = css({
    display: 'flex',
    alignItems: 'center',
    marginBottom: '.25rem',
  })
  const detailStyle = css({
    fontSize: '.7rem',
    color: '#666',
  })

  if (!provider && !offer) {
    return <p>{t('contractsTable:no_offer_data')}</p>
  }

  const showPrestation = situation && situation !== '-1'
  const color = showPrestation ? getPrestationColor(situation) : ''

  const badgeStyle = css({
    display: 'flex',
    alignItems: 'center',
    padding: '.125rem .25rem',
    backgroundColor: color,
    color: 'white',
    fontSize: '.75rem',
    textTransform: 'uppercase',
    fontWeight: 'bold',
    border: `2px solid ${color}`,
    borderRadius: '.25rem',
  })

  const showEnergyDetails = !!energyType

  return (
    <div className={containerStyle}>
      <div className={leftColumnStyle}>
        <div className={rowStyle}>{provider}</div>
        <div className={rowStyle}>{offer}</div>
        {showPrestation && (
          <div className={rowStyle}>
            <div className={badgeStyle}>
              <span>{situation}</span>
            </div>
          </div>
        )}
      </div>
      {showEnergyDetails && (
        <div className={rightColumnStyle}>
          {carGas !== null && carGas !== undefined && (
            <div className={detailStyle}>
              {t('contractsTable:carGas')}: {carGas}
            </div>
          )}
          {carElecBase !== null && carElecBase !== undefined && (
            <div className={detailStyle}>
              {t('contractsTable:carElecBase')}: {carElecBase}
            </div>
          )}
          {carElecHp !== null && carElecHp !== undefined && (
            <div className={detailStyle}>
              {t('contractsTable:carElecHp')}: {carElecHp}
            </div>
          )}
          {carElecHc !== null && carElecHc !== undefined && (
            <div className={detailStyle}>
              {t('contractsTable:carElecHc')}: {carElecHc}
            </div>
          )}
          {monthlyAmount !== null && monthlyAmount !== undefined && (
            <div className={detailStyle}>
              {t('contractsTable:monthlyAmount')}: {monthlyAmount}
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default OfferCell
